__turbopack_context__.v({
  "fadeIn": "styleConstants-module__FkpSba__fadeIn",
  "fadeInText": "styleConstants-module__FkpSba__fadeInText",
  "h1": "styleConstants-module__FkpSba__h1",
  "h2": "styleConstants-module__FkpSba__h2",
  "h3": "styleConstants-module__FkpSba__h3",
  "titleH": "styleConstants-module__FkpSba__titleH",
});
